import { useCallback } from "react";
import dateformat from "dateformat";
import { useSelector } from "react-redux";
import { UserProfileInline } from "app/components/UserProfileInline";
import moment from "moment";
import { useMutation } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { toast } from 'react-toastify';
import sanitizeHtml from 'sanitize-html';

export const BookDebateListItemView = ({ debate, isRoot = false, children, onReplyForm = f => f, onModifyForm = f => f, onSubDebateList = (f) => f, }) => {
    const auth = useSelector((state) => state.auth);

    //-------------- 삭제
    const commentDeleteMutate = useMutation({
        mutationFn: () => Api.get(`/api/book/${debate.isbn}/debate/${debate.id}/delete`),
        onSuccess: (res) => {
            debate.deleteYn = "Y";
            debate.content = "삭제된 댓글입니다.";
            debate.deletedAt = moment();
            // queryClient.setQueryData 를 사용안해도 되네.. ? 왜 되지? 
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    });

    const onDeleteComment = useCallback((event) => {
        if (!auth.authenticated) return;
        if (!auth.isSystemAdmin && debate?.user?.id !== auth.id) {
            toast.error('삭제 권한이 없습니다.');
            return;
        }

        if (!window.confirm("삭제하시겠습니까?")) return;
        commentDeleteMutate.mutate();
    }, [auth, commentDeleteMutate, debate]);

    if (debate === null) return null;
    let contentHtml = debate.content?.replace(/\n/gi, "<br />");
    if (debate.commentUserName !== null && debate.commentName !== null) {
        contentHtml =
            `<span class="toUser">@${debate.commentUserName || debate.commentName}</span>` + sanitizeHtml(contentHtml);
    }

    return (
        <div className={` reply reply_depth reply_depth_${debate.gdepth} ${debate.type} ${(debate.type === "system" || debate.gcount) > 0 ? "reply_box" : ""} ${debate.deleteYn === "Y" ? "delete" : ""}`}>
            <div>
                <UserProfileInline className="writer_info"
                    id={debate?.user?.id}
                    name={debate?.user?.name || debate.name} image={debate?.user?.image} type={debate?.user?.type}
                    school={debate?.user?.schoolName}
                    createdAt={moment(debate.createdAt).format("LLL")}
                />

                <div className={`text ${debate.deleteYn === "Y" ? "delete" : ""}`}>
                    <div className="depth_icon">
                        <p className="icon_number">{debate.gdepth}</p>
                        <div className="icon"></div>
                    </div>
                    {debate.deleteYn !== "Y" && <span className="content" dangerouslySetInnerHTML={{ __html: contentHtml }} ></span>}
                    {debate.deleteYn === "Y" && (
                        <span className="delete_time">
                            (삭제시간: {dateformat(debate.deletedAt, "yyyy.mm.dd HH:MM:ss")})
                        </span>
                    )}

                    <div className="btn_wrap">
                        {!isRoot && debate.deleteYn === "N" && auth.authenticated && (
                            <button type="button" className="btn _xsm write_btn" onClick={onReplyForm} >답글쓰기</button>
                        )}
                        {debate.deleteYn === "N" && debate.topicYn !== 'Y' && auth.authenticated && debate?.user?.id === auth.id && (
                            <button className="btn _xsm _blue btn_edit" onClick={onModifyForm} >수정</button>
                        )}

                        {debate.deleteYn === "N" && debate.topicYn !== 'Y' && auth.authenticated && debate?.user?.id === auth.id && (
                            <button className="btn _xsm _red btn_delete" onClick={onDeleteComment} >삭제</button>
                        )}
                    </div>
                </div>
                {isRoot && <button type="button" className="btn _sm _black reply_btn" onClick={onSubDebateList} >답글 {debate.gcount}</button>}
            </div>

            {children}
        </div>
    );
};